module.exports = __webpack_public_path__ + "static/media/thumbs-up.7c3fa875.svg";